"use strict";
exports.__esModule = true;
exports.defaultSassFormatterConfig = void 0;
exports.defaultSassFormatterConfig = {
    insertSpaces: true,
    tabSize: 2,
    convert: true,
    debug: false,
    deleteEmptyRows: true,
    deleteWhitespace: true,
    setPropertySpace: true,
    lineEnding: 'LF'
};
